import {
  CandidateVerification,
  CandidateVerificationHistory,
  ManagerOfCompany,
  Pagination,
  UserProcess,
} from '@interfaces';

export const searchProcessesDefaultPagination = {
  all: 0,
  limit: 25,
  offset: 0,
  orderBy: 'name',
  orderDir: 'desc',
  count: 0,
};

export const searchCandidateVerificationsDefaultPagination = {
  all: 0,
  limit: 25,
  offset: 0,
  orderBy: 'createdAt',
  orderDir: 'desc',
  count: 0,
};

export type ManagerState = Readonly<{
  loadingManagedCompanies: boolean;
  managedCompanies: ManagerOfCompany[] | null;

  loadingProcesses: boolean;
  processes: Partial<UserProcess>[];
  processesPagination: Pagination;

  loadingCandidateVerifications: boolean;
  candidateVerifications: Partial<CandidateVerification>[];
  candidateVerificationsPagination: Pagination;

  loadingCandidateVerificationDetails: boolean;
  candidateVerificationDetails: Partial<CandidateVerification> | null;

  loadingCandidateVerificationProcedureDecision: boolean;

  loadingCandidateVerificationHistory: boolean;
  candidateVerificationHistory: CandidateVerificationHistory[] | null;

  errorMessage: any;
}>;

export const initialState: ManagerState = {
  loadingManagedCompanies: false,
  managedCompanies: null,

  loadingProcesses: false,
  processes: [],
  processesPagination: { ...searchProcessesDefaultPagination } as Pagination,

  loadingCandidateVerifications: false,
  candidateVerifications: [],
  candidateVerificationsPagination: { ...searchCandidateVerificationsDefaultPagination } as Pagination,

  loadingCandidateVerificationDetails: false,
  candidateVerificationDetails: null,

  loadingCandidateVerificationProcedureDecision: false,

  loadingCandidateVerificationHistory: false,
  candidateVerificationHistory: null,

  errorMessage: null,
};
